module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3048926480/src/~/core-js/library/modules/_fails.js
// module id = nqvh
// module chunks = 6